import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["showModal", "setModal", "classes", "styles", "showCloseIcon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as Portal from '@radix-ui/react-portal';
import * as React from 'react';
import { Icon } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var Modal = function Modal(_ref) {
  var showModal = _ref.showModal,
      setModal = _ref.setModal,
      classes = _ref.classes,
      styles = _ref.styles,
      _ref$showCloseIcon = _ref.showCloseIcon,
      showCloseIcon = _ref$showCloseIcon === void 0 ? true : _ref$showCloseIcon,
      props = _objectWithoutProperties(_ref, _excluded);

  var closeModal = function closeModal() {
    setModal instanceof Function && setModal({
      show: false
    });
  };

  return showModal ? /*#__PURE__*/_jsxs(Portal.Root, _objectSpread(_objectSpread({
    className: "font-sans w-fill h-fill fixed flex items-center justify-center overflow-auto",
    style: {
      background: '#02556120',
      top: '0',
      left: '0',
      zIndex: 100
    }
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "w-fill h-fill fixed",
      style: {
        background: '#02556120',
        top: '0',
        left: '0',
        zIndex: -1
      },
      onClick: closeModal
    }), /*#__PURE__*/_jsxs("div", {
      className: "h-auto max-h-full absolute md:relative p-2 box-shadow bg-white flex flex-column scrollbar-none ".concat(classes, " br-2 md:my-3 w-full md:w-auto bottom-0 max-w-full lg:max-w-screen-xl lg:mx-auto md:px-4"),
      "data-cy": "showModal",
      style: _objectSpread({}, styles),
      children: [showCloseIcon && /*#__PURE__*/_jsx("span", {
        className: "mt-1 mr-2 c-gray-8 h3 clickable self-end",
        "data-cy": "close-modal",
        onClick: closeModal,
        children: /*#__PURE__*/_jsx(Icon, {
          name: "times",
          type: "regular",
          className: "text-gray-500 text-xl clickable self-end"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: 'px-1 py-1 pb-3 md:pb-10 md:px-3 overflow-auto',
        children: props.children
      })]
    })]
  })) : null;
};